import type { ThemeConfig } from "antd";
import enUS from "antd/locale/en_US";
import itIT from "antd/locale/it_IT";

export const antThemeConfig: ThemeConfig = {
  token: {
    colorPrimary: "#3867d6",
    colorSuccess: "#26de81",
    colorWarning: "#fed330",
    colorError: "#fc5c65",
    fontFamily: "var(--font-family-base)",
    borderRadius: 8,
    fontSize: 14,
  },
  components: {
    Button: {
      primaryShadow: "none",
      defaultShadow: "none",
    },
    Card: {
      paddingLG: 24,
    },
    Tabs: {
      itemColor: "var(--color-gray8)",
      itemSelectedColor: "var(--color-primary)",
      itemHoverColor: "var(--color-primary)",
      inkBarColor: "var(--color-primary)",
    },
  },
  hashed: false,
};

const localeMap: Record<string, typeof enUS> = {
  en: enUS,
  it: itIT,
};

export function getAntLocale(lang: string): typeof enUS {
  const base = lang?.slice(0, 2) ?? "en";
  return localeMap[base] ?? localeMap[lang ?? ""] ?? enUS;
}
